/* eslint-disable @typescript-eslint/no-explicit-any */
import { Heading, Text, useToast, VStack } from '@chakra-ui/react';
import { useProfile } from '../contexts/ProfileProvider';
import { useTheme } from '../contexts/ThemeProvider';
import { useEffect, useMemo, useState } from 'react';
import { useMutation } from 'react-query';
import { updateSubscription } from '@partiu/api/bookstore/api';
import { Button } from '../components/atoms/Button';
import { CPFInput } from '../components/atoms/Input';

export function DependentForm() {
  const { id, getValidSubscriptions } = useTheme();
  const { profile, updateProfile } = useProfile();
  const toast = useToast();

  const [extraCPFs, setExtraCPFs] = useState<any>([]);

  const subscription = useMemo(() => {
    if (!profile) return;
    const subscriptions = getValidSubscriptions(profile);

    return (subscriptions || []).filter((s) => s.plan.agreement.id === id)[0];
  }, [profile, getValidSubscriptions, id]);

  const updateSubscriptionMutation = useMutation(
    () => {
      if (!subscription) return Promise.reject('Subscription is undefined');
      return updateSubscription(subscription.id, { extra_cpfs: extraCPFs });
    },
    {
      onSuccess: function () {
        updateProfile({});
        toast({
          title: 'Sucesso',
          description:
            'Os CPFs foram vinculados com sucesso. Caso não tenham conta, cadastre-se usando a opção CPF Vinculado. Usuários já cadastrados poderão fazer login na plataforma usando a conta com o CPF cadastrado.',
          status: 'success',
        });
      },
      onError: function () {
        toast({ title: 'Oops!', description: 'Um dos CPFs digitados não é válido!', status: 'error' });
      },
    }
  );

  function updateCPFState(index: number, value: string) {
    const newArr = [...extraCPFs];
    newArr[index] = value;
    setExtraCPFs(newArr);
  }

  function getDependantText() {
    if (!subscription || subscription?.plan?.accessAmount === 1) return `Seu combo não permite dependentes.`;
    return `Olha que notícia boa! Identificamos que seu combo ${
      subscription?.plan.name
    } permite que você cadastre mais ${
      (subscription?.plan?.accessAmount ?? 0) - 1
    } CPF(s) para ter acesso gratuito a plataforma. Não perca tempo, cadastre agora.`;
  }

  useEffect(() => {
    if (!subscription) return;

    const newArr = new Array(subscription.plan.accessAmount - 1).fill('');
    subscription.extraCpfs.forEach((cpf, index) => (newArr[index] = cpf));
    setExtraCPFs(newArr);
  }, [subscription]);

  return (
    <VStack w={'100%'} align={'flex-start'} spacing={5}>
      <Heading fontSize={'21px'}>Seus Dependentes</Heading>
      <Text fontSize={'14px'}>{getDependantText()}</Text>
      <VStack width={'100%'} spacing={2}>
        <VStack spacing={2} w={'100%'}>
          {extraCPFs.length > 0 &&
            new Array(extraCPFs.length)
              .fill(0)
              .map((_, i) => (
                <CPFInput
                  width={'100%'}
                  mask="999.999.999-99"
                  key={i}
                  value={extraCPFs[i]}
                  onChange={(e) => updateCPFState(i, e.target.value)}
                  placeholder={`Dependente ${i + 1}`}
                />
              ))}
        </VStack>
        <Button
          isLoading={updateSubscriptionMutation.isLoading}
          onClick={() => updateSubscriptionMutation.mutate()}
          marginTop={'10px'}
          isDisabled={!subscription || subscription?.plan?.accessAmount === 1}
          width={'100%'}
        >
          Atualizar
        </Button>
      </VStack>
    </VStack>
  );
}
